import { useState } from 'react';
import { WorkspaceTabSummaryDTO } from 'domains/workspaceDetailDomain';
import workspaceDetailService from 'services/workspaceDetailService';
import { SimpleJobRevision } from 'domains/workspaceDomain';
import workspaceService from 'services/jobService';
import { useMount } from 'ahooks';

const useJobCardTabSummary = (id: number) => {
  const [summary, setSummary] = useState<WorkspaceTabSummaryDTO>();
  const [loading, setLoading] = useState(false);
  const [revisionList, setRevisionList] = useState<SimpleJobRevision[]>([]);
  useMount(async () => {
    setLoading(true);
    const summaryRes = await workspaceDetailService.getWorkspaceSummary(id);
    setSummary(summaryRes);
    const revisionList = await workspaceService.getJobRevisionList(id);
    setRevisionList(revisionList);
    setLoading(false);
  });
  return {
    summary,
    loading,
    revisionList,
  };
};
export default useJobCardTabSummary;
